import { useCallback } from 'react';
export function transformInlineCitations(contentText, sources) {
  return contentText.replace(
  // regexr.com/8gell
  /<!-- <cite>(([a-f\d-]{36},?)+)<\/cite> -->/g, (match, citationIds) => {
    const citationsLinks = citationIds.split(',').map(id => {
      const sourceIndex = sources.findIndex(source => source.citationId === id);
      const citedSource = sources[sourceIndex];
      if (citedSource) {
        return `<a title="${sources[sourceIndex].title}" href="tag:${sources[sourceIndex].citationId}">${sourceIndex + 1}</a>`;
      }
      return id;
    }).join('');
    return `<cite>${citationsLinks}</cite>`;
  });
}
const inlineCitationLinkClickHandler = ({
  e,
  sources,
  navigateToKnowledgeBaseArticle,
  browserWindowHeight
}) => {
  e.preventDefault();
  const href = e.target.href;
  const citationId = href.split('tag:')[1];
  const sourceData = sources.find(source => source.citationId === citationId);
  if (!sourceData) {
    return;
  }
  if (sourceData.hubSpotContentType === 'KB_ARTICLE' && typeof navigateToKnowledgeBaseArticle === 'function') {
    navigateToKnowledgeBaseArticle({
      deepLink: sourceData.deepLink,
      hubSpotContentId: sourceData.hubSpotContentId,
      hubSpotContentTextFragment: sourceData.hubSpotContentTextFragment
    }, browserWindowHeight, {
      view: 'thread-view'
    });
  } else {
    window.open(sourceData.deepLink || sourceData.url, '_blank');
  }
};
const inlineCitationMouseLeaveHandler = () => {
  const previews = document.querySelectorAll('#preview-citation');
  if (previews) {
    setTimeout(() => {
      previews.forEach(p => p.remove());
    }, 1000);
  }
};
const inlineCitationMouseOverHandler = ({
  e,
  sources
}) => {
  const href = e.target.href;
  const citationId = href.split('tag:')[1];
  const sourceData = sources.find(source => source.citationId === citationId);
  if (!sourceData) {
    return;
  }
  // Then use sourceData's title, url or deepLink, and richText to display a preview of the article
  // TODO: This is WIP, we may be leaning towards a modal which would be a React component
  const width = 360;
  const preview = document.createElement('div');
  preview.innerHTML = `<div><b><a href="${sourceData.deepLink || sourceData.url}" target="_blank">${sourceData.title}</a></b><p>${sourceData.richText || ''}</p></div>`;
  const previewStyle = {
    fontFamily: 'inherit',
    fontSize: '12px',
    lineHeight: '1.5',
    color: '#333',
    textAlign: 'left',
    wordBreak: 'break-word',
    position: 'absolute',
    top: `${e.clientY + 20}px`,
    // may need to put above if scrolled down
    left: `${(window.innerWidth - width) / 2}px`,
    width: `${width}px`,
    backgroundColor: 'white',
    border: '1px solid #ccc',
    borderRadius: '5px',
    padding: '10px',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)'
  };
  Object.assign(preview.style, previewStyle);
  preview.tabIndex = 0;
  preview.id = `preview-citation`;
  const existingPreview = document.getElementById('preview-citation');
  if (existingPreview) {
    existingPreview.remove();
  }
  document.body.appendChild(preview);
};
export function useInlineCitations({
  browserWindowHeight,
  navigateToKnowledgeBaseArticle,
  sources
}) {
  return useCallback(() => {
    const handleInlineCitationLinkClick = e => {
      inlineCitationLinkClickHandler({
        e,
        sources,
        navigateToKnowledgeBaseArticle,
        browserWindowHeight
      });
    };
    const handleInlineCitationMouseOver = e => {
      inlineCitationMouseOverHandler({
        e,
        sources
      });
    };
    const inlineCitationLinks = document.querySelectorAll('[data-test-use="agent"] a[href^="tag:"]');
    Array.from(inlineCitationLinks).filter(link => /^tag:[a-f\d-]{36}$/.test(link.href)).forEach(link => {
      link.removeEventListener('click', handleInlineCitationLinkClick);
      link.addEventListener('click', handleInlineCitationLinkClick);
      link.removeEventListener('mouseover', handleInlineCitationMouseOver);
      link.addEventListener('mouseover', handleInlineCitationMouseOver);
      link.removeEventListener('mouseleave', inlineCitationMouseLeaveHandler);
      link.addEventListener('mouseleave', inlineCitationMouseLeaveHandler);
    });
  }, [browserWindowHeight, navigateToKnowledgeBaseArticle, sources]);
}